import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Auto_Complete } from '../../../core/services/auto-complete';
import { HttpService } from '../../../core/services/api/http.service';
import { ErrorHandlingService } from '../../../core/services/error-handling.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize } from 'rxjs';
import { NotificationsService } from 'angular2-notifications';
import { ClaimApiService } from '../../../core/services/api/claim-api.service';
import { API_VERSIONS } from '../../consts/api-versions.const';

@UntilDestroy()
@Component({
  selector: 'app-select-product',
  templateUrl: './select-product.component.html',
  styleUrls: ['./select-product.component.scss']
})
export class SelectProductComponent implements OnInit {
  productFilter: Auto_Complete = new Auto_Complete(
    this._api,
    this.errHandle,
    `/${API_VERSIONS.PRODUCTS}/products`,
    true,
  );
  claimId!: number;
  form!: FormGroup;
  isSubmitLoading = false;

  constructor(
    private ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private _api: HttpService,
    private errHandle: ErrorHandlingService,
    private notificationService: NotificationsService,
    private fb: FormBuilder,
    private claimApiService: ClaimApiService,
  ) { }

  ngOnInit(): void {
    this.claimId = this.config?.data?.claimId;
    this.initForm();
    this.productFilter.options = {
      ...this.productFilter.options,
      include_atlantic_products: true
    }
  }

  initForm() {
    this.form = this.fb.group({
      product: [null, Validators.required],
    });
  }

  close(payload?: any) {
    this.ref.close(payload);
  }

  cancelClicked() {
    this.close();
  }

  saveClicked() {
    if (this.form.invalid || !this.form.touched) {
      this.form.markAllAsTouched()
      return;
    }
    this.isSubmitLoading = true;
    const productId = this.form?.value?.product?.id;
    if (!productId || !this.claimId) return; 
    this.claimApiService.copyMilestonesFromProduct(this.claimId, productId)
      .pipe(untilDestroyed(this), finalize(() => this.isSubmitLoading = false))
      .subscribe({
        next: (res) => {
          this.notificationService.success(res?.message ||  'Milestones are copied successfully');
          this.close({shouldReload: true});
        },
        error: (err) => {
          this.errHandle.errorHandling(err);
        }
      });
  }

  protected readonly Validators = Validators;
}
